import { useCallback, useEffect, useState } from 'react';
import type { SellerConnection } from '../../api/amazonconnect';
import type { CompareMode, DatePreset } from '../types';
import { loadIndiaMap } from './loadIndiaMap';
import type { IndiaMapModel } from './types';

export function useIndiaMap(opts: {
  refreshToken?: number;
  connection: SellerConnection | null;
  datePreset: DatePreset;
  compare: CompareMode;
}) {
  const { refreshToken = 0, connection, datePreset, compare } = opts;
  const [model, setModel] = useState<IndiaMapModel | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      if (!connection?.id) {
        setModel(null);
        setError(null);
        return;
      }
      const m = await loadIndiaMap({ connection, datePreset, compare });
      setModel(m);
      if (m?.error) setError(m.error);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to load India map');
      setModel(null);
    } finally {
      setLoading(false);
    }
  }, [connection, datePreset, compare]);

  useEffect(() => {
    void reload();
  }, [reload, refreshToken]);

  return { model, loading, error, reload };
}
